import { AppStartListening } from '../store'
import { consumerApi } from '../../lib/consumer-api/consumer-api'
import { bettingSlice } from '../../lib/betting/betting.slice'

export const addPlayerPropListeners = (startAppListening: AppStartListening) => {
  startAppListening({
    matcher: consumerApi.endpoints.getCurrentEventWeek.matchFulfilled,
    effect: async (action, listenerApi) => {
      // Can cancel other running instances
      listenerApi.cancelActiveListeners()
      const { abbreviation, season } = action.payload
      listenerApi.dispatch(bettingSlice.actions.setCurrentEventWeek(abbreviation))
      listenerApi.dispatch(bettingSlice.actions.setPlayerPropWeekFilter(abbreviation))
      listenerApi.dispatch(bettingSlice.actions.setSeason(String(season)))
    },
  })
}
